import React, { Component } from "react";

export class RoundButton extends Component {
    render() {
        return (
            <button type="button" className={"btn " + this.props.type} disabled={this.props.disabled} onClick={this.props.onClick}>{ this.props.data || this.props.children }</button> 
        )
    }
};